module.exports = __webpack_public_path__ + "static/media/openflow_image.29055def.svg";